import styled from 'styled-components'
import { motion } from 'framer-motion'

export const Content = styled(motion.div)`

`

export const Title = styled(motion.h3)`
    margin: 0 0 1rem 0;
`

export const RadioInner = styled(motion.div)`
    display: flex;
    margin-bottom: 1rem;
    
    @media screen and (max-width: 1050px) {
        flex-wrap: wrap;
        width: 75%;
    }
`

export const RadioLabel = styled(motion.label)`
    input {
        opacity: 0;
        // pointer-events: none;
        cursor: default;
        &:checked + div {
            border: 3px solid black;
        }
    }
`

export const RadioButton = styled.div`
    width: 2rem;
    height: 2rem;
    padding: .2rem;
    background: ${({color}) => color};
    border: ${({color}) => color === '#ffffff' ? '1px solid black' : 'none'};
    border-radius: 50%;
    box-sizing: border-box;
    margin: .2rem;
    cursor: pointer;

    @media screen and (max-width: 650px) {
        width: calc(.5rem + 4vw);
        height: calc(.5rem + 4vw);
    }
`

export const Note = styled(motion.p)`
    font-size: .7rem;
`